// import React, { useState } from "react";
// import axios from "axios";

// const CreatePlatter = () => {
//   const [formData, setFormData] = useState({
//     platterType: "",
//     foodItems: [],
//   });

//   const [newItem, setNewItem] = useState({
//     title: "",
//     desc: "",
//     price: "",
//     imageUrl: "",
//     availability: true,
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setNewItem({
//       ...newItem,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   const handleAddItem = () => {
//     // Validate the new item before adding it to the list
//     if (
//       !newItem.title ||
//       !newItem.desc ||
//       !newItem.price ||
//       !newItem.imageUrl
//     ) {
//       alert("Please fill all fields for the new item.");
//       return;
//     }

//     setFormData({
//       ...formData,
//       foodItems: [...formData.foodItems, newItem],
//     });
//     setNewItem({
//       title: "",
//       desc: "",
//       price: "",
//       imageUrl: "",
//       availability: true,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate the platter type and food items
//     if (!formData.platterType) {
//       alert("Please provide a platter type.");
//       return;
//     }

//     if (formData.foodItems.length === 0) {
//       alert("Please add at least one food item.");
//       return;
//     }

//     try {
//       const response = await axios.post(
//         "https://ekhoni-khabo-server.vercel.app/api/v1/custom/platter",
//         formData
//       );
//       alert("Platter created successfully!");
//       console.log(response.data);
//       setFormData({
//         platterType: "",
//         foodItems: [],
//       });
//     } catch (error) {
//       console.error("Error creating platter:", error);
//     }
//   };

//   return (
//     <div className="flex justify-center items-center min-h-screen bg-gray-100 pl-[64px]">
//       <form
//         onSubmit={handleSubmit}
//         className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md"
//       >
//         <h2 className="text-2xl font-bold mb-6 text-center">
//           Create New Platter
//         </h2>

//         {/* Platter Type */}
//         <div className="mb-4">
//           <label className="block font-semibold mb-1">Platter Type</label>
//           <input
//             name="platterType"
//             value={formData.platterType}
//             onChange={(e) =>
//               setFormData({ ...formData, platterType: e.target.value })
//             }
//             placeholder="Enter platter type"
//             className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
//             required
//           />
//         </div>

//         {/* Add New Item Section */}
//         <div className="mb-4">
//           <h3 className="text-lg font-semibold mb-2">Add New Item</h3>

//           {/* Item Title */}
//           <div className="mb-2">
//             <label className="block font-semibold mb-1">Title</label>
//             <input
//               name="title"
//               value={newItem.title}
//               onChange={handleChange}
//               placeholder="Enter item title"
//               className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
//               required
//             />
//           </div>

//           {/* Item Description */}
//           <div className="mb-2">
//             <label className="block font-semibold mb-1">Description</label>
//             <input
//               name="desc"
//               value={newItem.desc}
//               onChange={handleChange}
//               placeholder="Enter description"
//               className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
//               required
//             />
//           </div>

//           {/* Item Price */}
//           <div className="mb-2">
//             <label className="block font-semibold mb-1">Price</label>
//             <input
//               name="price"
//               value={newItem.price}
//               onChange={handleChange}
//               placeholder="Enter price"
//               className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
//               required
//             />
//           </div>

//           {/* Item Image URL */}
//           <div className="mb-2">
//             <label className="block font-semibold mb-1">Image URL</label>
//             <input
//               name="imageUrl"
//               value={newItem.imageUrl}
//               onChange={handleChange}
//               placeholder="Enter image URL"
//               className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
//               required
//             />
//           </div>

//           {/* Item Availability */}
//           <div className="mb-4 flex items-center">
//             <input
//               type="checkbox"
//               name="availability"
//               checked={newItem.availability}
//               onChange={handleChange}
//               className="mr-2"
//             />
//             <label className="font-semibold">Available</label>
//           </div>

//           {/* Add Item Button */}
//           <button
//             type="button"
//             onClick={handleAddItem}
//             className="w-full bg-blue-500 text-white p-2 rounded-lg font-bold hover:bg-blue-600 transition mb-4"
//           >
//             Add Item
//           </button>
//         </div>

//         {/* Display Added Items */}
//         <div className="mb-4">
//           <h3 className="text-lg font-semibold mb-2">Added Items</h3>
//           {formData.foodItems.length > 0 ? (
//             <ul className="space-y-2">
//               {formData.foodItems.map((item, index) => (
//                 <li key={index} className="border p-2 rounded-lg">
//                   <p className="font-semibold">{item.title}</p>
//                   <p className="text-sm text-gray-600">{item.desc}</p>
//                   <p className="text-sm text-green-600">${item.price}</p>
//                 </li>
//               ))}
//             </ul>
//           ) : (
//             <p className="text-gray-500">No items added yet.</p>
//           )}
//         </div>

//         {/* Submit Button */}
//         <button
//           type="submit"
//           disabled={formData.foodItems.length === 0}
//           className={`w-full bg-green-500 text-white p-3 rounded-lg font-bold hover:bg-green-600 transition ${
//             formData.foodItems.length === 0
//               ? "opacity-50 cursor-not-allowed"
//               : ""
//           }`}
//         >
//           Create Platter
//         </button>
//       </form>
//     </div>
//   );
// };

// export default CreatePlatter;

import React, { useState } from "react";
import axios from "axios";

const CreatePlatter = () => {
  const [formData, setFormData] = useState({
    platterType: "",
    foodItems: [],
  });

  const [newItem, setNewItem] = useState({
    title: "",
    desc: "",
    price: "",
    category: "",
    imageUrl: "",
    availability: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewItem({
      ...newItem,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleAddItem = () => {
    // Validate the new item before adding it to the list
    if (
      !newItem.title ||
      !newItem.desc ||
      !newItem.price ||
      !newItem.category ||
      !newItem.imageUrl
    ) {
      alert("Please fill all fields for the new item.");
      return;
    }

    setFormData({
      ...formData,
      foodItems: [...formData.foodItems, newItem],
    });
    setNewItem({
      title: "",
      desc: "",
      price: "",
      category: "",
      imageUrl: "",
      availability: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the platter type
    if (!formData.platterType) {
      alert("Please provide a platter type.");
      return;
    }

    // Validate that at least one item is added
    if (formData.foodItems.length === 0) {
      alert("Please add at least one food item.");
      return;
    }

    try {
      const response = await axios.post(
        "https://ekhoni-khabo-server.vercel.app/api/v1/custom/platter",
        formData
      );
      alert("Platter created successfully!");
      console.log(response.data);
      setFormData({
        platterType: "",
        foodItems: [],
      });
    } catch (error) {
      console.error("Error creating platter:", error);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 pl-[64px]">
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md"
        noValidate // Disable browser validation
      >
        <h2 className="text-2xl font-bold mb-6 text-center">
          Create New Platter
        </h2>

        {/* Platter Type */}
        <div className="mb-4">
          <label className="block font-semibold mb-1">Platter Type</label>
          <input
            name="platterType"
            value={formData.platterType}
            onChange={(e) =>
              setFormData({ ...formData, platterType: e.target.value })
            }
            placeholder="Enter platter type"
            className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
          />
        </div>

        {/* Add New Item Section */}
        <div className="mb-4">
          <h3 className="text-lg font-semibold mb-2">Add New Item</h3>

          {/* Item Title */}
          <div className="mb-2">
            <label className="block font-semibold mb-1">Title</label>
            <input
              name="title"
              value={newItem.title}
              onChange={handleChange}
              placeholder="Enter item title"
              className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            />
          </div>

          {/* Item Description */}
          <div className="mb-2">
            <label className="block font-semibold mb-1">Description</label>
            <input
              name="desc"
              value={newItem.desc}
              onChange={handleChange}
              placeholder="Enter description"
              className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            />
          </div>

          {/* Item Price */}
          <div className="mb-2">
            <label className="block font-semibold mb-1">Price</label>
            <input
              name="price"
              value={newItem.price}
              onChange={handleChange}
              placeholder="Enter price"
              className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            />
          </div>

          <div className="mb-2">
            <label className="block font-semibold mb-1">Category</label>
            <input
              name="category"
              value={newItem.category}
              onChange={handleChange}
              placeholder="Enter category"
              className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            />
          </div>

          {/* Item Image URL */}
          <div className="mb-2">
            <label className="block font-semibold mb-1">Image URL</label>
            <input
              name="imageUrl"
              value={newItem.imageUrl}
              onChange={handleChange}
              placeholder="Enter image URL"
              className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            />
          </div>

          {/* Item Availability */}
          <div className="mb-4 flex items-center">
            <input
              type="checkbox"
              name="availability"
              checked={newItem.availability}
              onChange={handleChange}
              className="mr-2"
            />
            <label className="font-semibold">Available</label>
          </div>

          {/* Add Item Button */}
          <button
            type="button"
            onClick={handleAddItem}
            className="w-full bg-blue-500 text-white p-2 rounded-lg font-bold hover:bg-blue-600 transition mb-4"
          >
            Add Item
          </button>
        </div>

        {/* Display Added Items */}
        <div className="mb-4">
          <h3 className="text-lg font-semibold mb-2">Added Items</h3>
          {formData.foodItems.length > 0 ? (
            <ul className="space-y-2">
              {formData.foodItems.map((item, index) => (
                <li key={index} className="border p-2 rounded-lg">
                  <p className="font-semibold">{item.title}</p>
                  <p className="text-sm text-gray-600">{item.desc}</p>
                  <p className="text-sm text-green-600">${item.price}</p>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No items added yet.</p>
          )}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-green-500 text-white p-3 rounded-lg font-bold hover:bg-green-600 transition"
        >
          Create Platter
        </button>
      </form>
    </div>
  );
};

export default CreatePlatter;
